<button
  class="icon"
  [class.disabled]="disabled"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel || null"
  (click)="emitClick($event)"
  [andorTooltip]="tooltip">
  <ng-content></ng-content>
</button>
